// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChargingProgress_wrapper__Y1Op2","progress":"ChargingProgress_progress__38Umg","lighting":"ChargingProgress_lighting__133SQ"};